// extracted by mini-css-extract-plugin
export var dataCell = "_qa-2";
export var dataRow = "_qa-0";
export var headerRow = "_qa-1";